module.exports = __webpack_public_path__ + "media/meeting2.24fd895e.mp4";